import React from "react";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import {grey} from "@material-ui/core/colors";
import {Tooltip} from "@material-ui/core";

const DisabledShopIcon = ({tooltipTitle = ""}: {tooltipTitle?: string}) => {
  return (
    <Tooltip title={tooltipTitle}>
      <VisibilityOffIcon htmlColor={grey[400]} />
    </Tooltip>
  );
};

export default DisabledShopIcon;
